import type { ContentPage } from "@/lib/content/types";

// MIGRATED (Phase 3): faithful port of the former hand-coded
// app/(homes)/(hrms)/hrms-software/leave-management-system/leave-accrual-details/page.jsx onto the content
// engine (template "hrmsFeature"). Copy, images, links and heading levels
// match the original. SEO still comes from GeneralPageSEOMetadata.json via
// <SEO> (its "leave-accrual-details" entry is kept); the seo block below is a fallback.

export const leaveAccrualDetails: ContentPage = {
  slug: "leave-management-system/leave-accrual-details",
  template: "hrmsFeature",
  seo: {
    title: "Leave Accrual System - Automate Employee Leave Accruals",
    description: "Automate leave accruals based on employee tenure and company policies. Ensure accurate leave balance tracking with our Leave Accrual system.",
    keywords: [
      "leave accrual system",
      "employee leave accruals",
      "automated leave accrual",
      "HR leave tracking",
      "leave balance automation",
      "leave accrual policy",
    ],
    ogImage: "/assets/data/seoimages/leave-accrual-details.webp",
  },
  leaf: {
    hero: {
      caption: "Leave Accrual Details",
      title: "Automated Leave Accruals for Accurate Balance Calculations",
      description: "Ensure accurate leave balance tracking with automated accruals based on employee tenure, role, and company policies.",
      h1: "caption",
    },
    split: {
      title: "Seamless Leave Accruals for Superior Operational Efficiency",
      bullets: [
        { title: "Customizable Accrual Policies", description: "Define varying accrual rates for different employee groups based on tenure or role." },
        { title: "Flexible Accrual Scheduling", description: "Automate accruals monthly, quarterly, or annually based on your company’s policies." },
        { title: "Automatic Balance Adjustments", description: "The system updates leave balances in real-time based on accrued and used leave." },
        { title: "Prorated Accruals for New Hires", description: "Automatically calculate prorated leave for new or part-time employees." },
      ],
      image: "/assets/images/img/product/hrms/leavems/leave-accrual-details.webp",
      imageAlt: "leave-accrual-details",
    },
    cardsHeading: {
      title: "Key Features of Leave Management System",
      description: "Optimize leave management with advanced features designed to streamline tracking, automation, and customization.",
    },
    cards: [
      {
        title: "Leave Balance",
        href: "/hrms-software/leave-management-system/leave-balance",
        description: "Keep track of employee leave balances in real-time, ensuring transparency and accurate record-keeping.",
        image: "/assets/images/img/product/hrms/leavems/leave_balance_features.webp",
        imageAlt: "leave_balance",
      },
      {
        title: "Leave Policy & Allocation",
        href: "/hrms-software/leave-management-system/leave-policy-allocation",
        description: "Create and manage leave policies tailored to your organization’s needs. Allocate leaves based on roles, seniority, and more.",
        image: "/assets/images/img/product/hrms/leavems/leave_policy_and_allocation.webp",
        imageAlt: "leave_policy_and_allocation",
      },
      {
        title: "Easy Approval",
        href: "/hrms-software/leave-management-system/leave-approval/",
        description: "Facilitate quick and easy leave request approvals or declines with a user-friendly workflow, keeping your HR processes efficient.",
        image: "/assets/images/img/product/hrms/leavems/easy_approval_decline.webp",
        imageAlt: "easy_approval",
      },
      {
        title: "Leave Dashboard",
        href: "/hrms-software/leave-management-system/leave-dashboard/",
        description: "Get a comprehensive overview of leave requests, approvals, and balances in a single, user-friendly dashboard for seamless management.",
        image: "/assets/images/img/product/hrms/leavems/leave-dashboard.webp",
        imageAlt: "leave_dashboard_overview",
      },
    ],
    testimonials: {
      title: "What Our Customers Say",
      description: "Our clients consistently praise the design and functionality of our templates.",
    },
    bookDemoTitle: "Automate Your Leave Accruals",
    relatedBlogsKeyword: "real-time-leave-tracking",
    metaKey: "leave-accrual-details",
  },
  sections: [],
};
